//messages.js
export default {
    company: "Company",
    website: "Website",
    turn_around_days: "Turn Around Days",
    correspondence_method: "Correspondence Method",
    has_nda: "Has Nda",
    has_contract: "Has Contract",
    ship_label_type: "Ship Label Type",
    edit_customer: "Edit Customer",
    add_customer: "Add Customer",
    delete_customer: "Delete Customer",
    customers: "Customers",
    delete_customer_confirm: "This action is not reversible!",
    shipping_number: "Shipping Number",
    billing_method: "Billing Method",
};
